import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {NOTIFICATION_COMPONENTS} from './components';
import {LetDirective, PushPipe} from '@ngrx/component';
import {SharedModule} from '../../shared-modules/shared-module/shared-module.module';
import {SharedIconsModule} from '../../shared-modules/shared-icons/shared-icons.module';
import {SharedComponentsModule} from '../../shared/shared-components/shared-components.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UiComponentsModule} from '../../shared/shared-module-ui/ui-components.module';
import {AddStockItemModule} from '../stock-manager/components/add-stock-item/add-stock-item.module';
import {AgGridAngular} from 'ag-grid-angular';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ScrollingModule} from '@angular/cdk/scrolling';

@NgModule({
  declarations: [
    ...NOTIFICATION_COMPONENTS,
  ],
  providers: [
    DatePipe,
  ],
  imports: [
    CommonModule,
    PushPipe,
    SharedIconsModule,
    SharedModule,
    SharedComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    UiComponentsModule,
    AddStockItemModule,
    AgGridAngular,
    MatTooltipModule,
    ScrollingModule,
    LetDirective,
  ],
  exports: [
    ...NOTIFICATION_COMPONENTS,
  ],
})
export class NotificationsModule {
}
